import { DomPortalOutlet } from '@angular/cdk/portal';

import { inject, Injectable, DOCUMENT } from '@angular/core';
import { v4 as uuid } from 'uuid';

export interface AppPortalOutlet {
  id: string;
  instance: DomPortalOutlet;
  dispose: () => void;
}

@Injectable({ providedIn: 'root' })
export class PortalService {
  private document = inject(DOCUMENT);

  createPortalOutlet(id: string = uuid()): AppPortalOutlet {
    const portalOutletEl = this.document.createElement('div');
    portalOutletEl.id = `${id}__portal-outlet`;
    portalOutletEl.classList.add('app-portal-outlet');

    this.document.body.appendChild(portalOutletEl);

    const portalOutlet = new DomPortalOutlet(portalOutletEl);

    return {
      id,
      get instance() {
        return portalOutlet;
      },
      dispose: () => {
        if (portalOutlet.hasAttached) {
          portalOutlet.detach();
        }

        portalOutlet.dispose();

        portalOutletEl.remove();
      }
    };
  }
}
